<template>
  <v-container>
    <h2>Admin information</h2>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Firstname:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.firstname || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Lastname:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.lastname || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Username:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.username || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Email:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.email || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Phone number:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.phone_number || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Line ID:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.line_id || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Role:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ user.role || '-' }}</p>
          </v-col>
        </v-row>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'user-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "UserView",
  components: { },
  data: () => ({
    user: {
      id: null,
      firstname: null,
      lastname: null,
      username: null,
      email: null,
      phone_number: null,
      line_id: null,
      role: null
    },
  }),
  async mounted () {
    this.user.id = this.$route.params.id
    await this.getUser()
  },
  methods: {
    async getUser () {
      try {
        const { data } = await this.$http.get(`/back-office/admins/${this.user.id}`, authHeader())
        this.user.firstname = data.firstname
        this.user.lastname = data.lastname
        this.user.email = data.email
        this.user.username = data.username
        this.user.phone_number = data.phone_number
        this.user.line_id = data.line_id
        this.user.role = data.role
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    }
  },
};
</script>
